"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { Button } from './button.mjs';

const IconButton = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(Button, { ref, className: clsx("px-0", className), ...props }));
IconButton.displayName = "IconButton";

export { IconButton };
